import React from 'react';
import styles from './onboardingHero.module.css';

interface HeroBottomMessageProps {
  lineOne: string;
  lineTwo: string;
}

const HeroBottomMessage: React.FC<HeroBottomMessageProps> = ({ lineOne, lineTwo }) => (
  <div className={styles.bottomMessage}>
    <p className={styles.bottomMessageText}>
      {lineOne}
      <br />
      {lineTwo}
    </p>
  </div>
);

export default HeroBottomMessage;
